
export const validadorCedula = (documento, tipoPersona, tipoDocumento) => {
  let estado;
  let validaregion;
  let validalongitud;
  let digitoRegion;
  let cedulatrasformar = [];
  let dtores;
  let ultimotresdigitos;
  digitoRegion = documento.substring(0, 2);
  cedulatrasformar = documento.split('');
  validaregion = validarregion(Number(digitoRegion));
  const tercerdigito = cedulatrasformar[2];
  switch (tipoDocumento) {
    case 'CEDULA': {
      if (validaregion) {
        validalongitud = validarlongitud(documento, tipoDocumento);
        if (validalongitud) {
          if (tercerdigito !== '9' && tercerdigito !== '6') {
            if (
              Number(documento.substring(2, 3)) < 7 &&
              tipoPersona === TipoPersona.Natural
            ) {
              if (Number(documento.substring(2, 3)) !== 6) {
                estado = verificaCedulaEcuador(cedulatrasformar);
                if (estado) {
                  dtores = { bdt1: true, dt1: '' };
                } else {
                  dtores = {
                    bdt1: false,
                    dt1: 'Dígito verificador es inválido en cédula.',
                  };
                }
              } else {
                dtores = { bdt1: true, dt1: '' };
              }
            } else {
              dtores = {
                bdt1: false,
                dt1: 'Cédula inválida para persona jurídica.',
              };
            }
          } else {
            dtores = {
              bdt1: false,
              dt1:
                'El tercer dígito debe ser diferente de 9 o 6 para cédula.',
            };
          }
        } else {
          dtores = { bdt1: false, dt1: 'Tamaño de cédula inválido.' };
        }
      } else {
        dtores = {
          bdt1: false,
          dt1:
            'Número de documento inválido debe pertenecer al rango de regiones de ECUADOR.',
        };
      }
      break;
    }
    case 'RUC': {
      if (validaregion) {
        validalongitud = validarlongitud(documento, tipoDocumento);
        if (validalongitud) {
          ultimotresdigitos =
            cedulatrasformar[10] +
            cedulatrasformar[11] +
            cedulatrasformar[12];
          if (ultimotresdigitos === '001') {
            switch (tipoPersona) {
              case TipoPersona.Natural: {
                if (tercerdigito !== '9' && tercerdigito !== '6') {
                  if (Number(documento.substring(2, 3)) < 7) {
                    estado = verificaCedulaEcuador(cedulatrasformar);
                    if (estado) {
                      dtores = { bdt1: true, dt1: '' };
                    } else {
                      dtores = {
                        bdt1: false,
                        dt1:
                          'Digito verificador es inválido en RUC para tipo persona natural.',
                      };
                    }
                  } else {
                    estado = verificaPersonaJuridicaEcuador(
                      cedulatrasformar
                    );
                    if (estado) {
                      dtores = { bdt1: estado, dt1: '' };
                    } else {
                      dtores = {
                        bdt1: false,
                        dt1: 'RUC inválido para persona natural.',
                      };
                    }
                  }
                } else {
                  dtores = {
                    bdt1: false,
                    dt1:
                      'El tercer dígito debe ser diferente de 9 o 6 para RUC de tipo persona Natural.',
                  };
                }
                break;
              }

              case TipoPersona.Juridica: {
                if (tercerdigito === '9' || tercerdigito === '6') {
                  if (tercerdigito === '9') {
                    estado = verificaPersonaJuridicaEcuador(
                      cedulatrasformar
                    );
                    if (estado) {
                      dtores = { bdt1: true, dt1: '' };
                    } else {
                      dtores = {
                        bdt1: false,
                        dt1: 'RUC inválido para persona jurídica.',
                      };
                    }
                  } else {
                    estado = this.verificaSectorPublicoEcuador(
                      cedulatrasformar
                    );
                    if (estado) {
                      dtores = { bdt1: estado, dt1: '' };
                    } else {
                      dtores = {
                        bdt1: false,
                        dt1: 'RUC inválido para persona jurídica.',
                      };
                    }
                  }
                } else {
                  dtores = {
                    bdt1: false,
                    dt1:
                      'El tercer dígito debe ser 9 o 6 para RUC de tipo persona Jurídica.',
                  };
                }
                break;
              }
            }
          } else {
            dtores = {
              bdt1: false,
              dt1: 'RUC inválido debe determinar en 001.',
            };
          }
        } else {
          dtores = { bdt1: false, dt1: 'Tamaño de RUC inválido.' };
        }
      } else {
        dtores = {
          bdt1: false,
          dt1:
            'Número de documento inválido debe pertenecer al rango de regiones de ECUADOR.',
        };
      }
      break;
    }
    default: {
      dtores = { bdt1: true, dt1: '' };
      break;
    }
  }

  return dtores;

};

export const validarlongitud = (documento, tipoDocumento) => {
  let respuesta;
  switch (tipoDocumento) {
    case 'CEDULA': {
      if (documento.length === 10) {
        respuesta = true;
      } else {
        respuesta = false;
      }
      break;
    }
    case 'RUC': {
      if (documento.length === 13) {
        respuesta = true;
      } else {
        respuesta = false;
      }
      break;
    }
    default: {
      respuesta = true;
      break;
    }
  }
  return respuesta;
}
export const verificaCedulaEcuador = (cedula) => {
  let aux = 0;
  let par = 0,
    impar = 0,
    verifi = 0;
  let i;
  for (i = 0; i < 9; i += 2) {
    aux = 2 * Number(cedula[i]);
    if (aux > 9) {
      aux -= 9;
    }
    par += aux;
  }
  for (i = 1; i < 9; i += 2) {
    impar += Number(cedula[i]);
  }

  aux = par + impar;
  if (aux % 10 !== 0) {
    verifi = 10 - (aux % 10);
  } else {
    verifi = 0;
  }
  if (verifi === Number(cedula[9])) {
    return true;
  } else {
    return false;
  }
}
export const validateEmail = (text) => {
  let valodador;
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
  if (reg.test(text) === false) {

    valodador = {
      bdt1: false,
      dt1: 'El correo es inválido.',
    };

  }
  else {
    valodador = {
      bdt1: true,
      dt1: '',
    };
  }
  return valodador;

}

    /**
     * Método para validar ruc
     * @param cedula
     */
    export const  verificaSectorPublicoEcuador=(cedula)=> {
      let aux = 0,
          prod = 0,
          veri = 0;
      let coeficiente;
      let i;
      veri =
          Number(cedula[9]) +
          Number(cedula[10]) +
          Number(cedula[11]) +
          Number(cedula[12]);
      if (veri > 0) {
          coeficiente = [3, 2, 7, 6, 5, 4, 3, 2];
          for (i = 0; i < 8; i++) {
              prod = Number(cedula[i]) * coeficiente[i];
              aux += prod;
          }

          if (aux % 11 === 0) {
              veri = 0;
          } else if (aux % 11 === 1) {
              return false;
          } else {
              aux = aux % 11;
              veri = 11 - aux;
          }
          if (veri === Number(cedula[8])) {
              return true;
          } else {
              return false;
          }
      } else {
          return false;
      }
  }

/**
 * Método para validar persona jurídica
 * @param cedula
 */
export const verificaPersonaJuridicaEcuador=(cedula) => {
  let aux = 0;
  let prod = 0;
  let veri = 0;
  let coeficiente
  var acu=0;
  var valor;
  veri = cedula[10] + cedula[11] + cedula[12];
  var dto = cedula.length;
  for (var i=0; i<dto; i++){
    valor = cedula.toString().substring(i,i+1);
    if(valor==0||valor==1||valor==2||valor==3||valor==4||valor==5||valor==6||valor==7||valor==8||valor==9){
     acu = acu+1;
    }
  }

  if(acu==dto){
    return false
  }else{
    return true
  }
}
export const validarregion = (region) => {
  let res;
  if ((region >= 1 && region <= 24) || region == 30) {
    res = true;
  } else {
    res = false;
  }
  return res;
}
const TipoPersona = {
  Natural: 1,
  Juridica: 2,
}